import React, { useEffect, useState } from 'react';
import './projetos2.css'
import HomeLf from './HomeLf';
import { db, firebaseAuth } from '../utils/firebase-config';
import { onAuthStateChanged } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { collection, doc, getDocs, updateDoc } from 'firebase/firestore';
import addicon from '../assets/version2/addicon.png';
import circleadd from '../assets/version2/circleadd.png';
import Rodape from './Rodape';
import './criarordemmodal.css';
import HomeOff from './HomeOff';
function PoliticasDePrivacidade(params) {

  const navigate = useNavigate();
const [current, setCurrent] = useState('');
const [logado, setLogado] = useState(false);



async function master(params) {
  


    onAuthStateChanged(firebaseAuth, async (currentUser) => {
            if (currentUser) {setLogado(true);
             setCurrent(currentUser.email);
         







        } else {
            
        }
          });





}


useEffect(()=> {

  master();

},[])


    return (
      <>
        <div>


  {logado == true ? <><HomeLf/></> : <> <HomeOff/></>}
<div className="fixmargin"></div>

<div className="row" style={{ marginTop: 50, padding: "0px 120px", paddingBottom: '200px' }}>
        <h1 style={{color: '#323743', fontSize: '48px', fontFamily: "Archivo, serif", fontWeight: 'bold'}}>Política de privacidade do Lumera 3D</h1>
       <div style={{fontSize: '14px', fontFamily: "Inter, serif", paddingTop: '50px'}}>
<a style={{fontWeight: 'bold'}}>Data de Vigência:</a> 06 de janeiro de 2025.
<br/>
<div style={{ marginTop: '25px'}}>
    No <a style={{fontWeight: 'bold'}}>Lumera 3D</a> , a sua privacidade é uma prioridade.
     Esta Política de Privacidade foi elaborada para informar como coletamos,
      usamos, armazenamos e protegemos os seus dados pessoais, 
      em conformidade com a <a style={{fontWeight: 'bold'}}>Lei Geral de Proteção de Dados Pessoais (LGPD)</a> - Lei nº 13.709/2018.
</div>
<div style={{ marginTop: '25px'}}>
Nosso compromisso é garantir transparência e segurança no tratamento 
das suas informações. Ao utilizar o site e nossos serviços, 
você concorda com os termos descritos nesta Política de Privacidade.
 Por isso, recomendamos que leia atentamente este documento.
</div>


<div style={{ marginTop: '25px'}}>
Abaixo, explicaremos:
<li>Quais dados coletamos e como os utilizamos.</li>
<li>Seus direitos como titular de dados pessoais.</li>
<li>As medidas que adotamos para proteger suas informações.</li>
</div>



<div style={{ marginTop: '25px'}}>
   
Se restar alguma dúvida, estamos à disposição através do e-mail<a style={{fontWeight: 'bold'}}> contato@lumera3d.com. </a>
 Sua confiança é essencial para nós, e nos empenhamos em mantê-la com práticas éticas e transparentes.
<a style={{fontWeight: 'bold'}}> Vamos juntos explorar o mundo do 3D de maneira segura e confiável.</a>
</div>
<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>1. DADOS COLETADOS</a> <br/>
O Lumera 3D coleta informações pessoais e não pessoais com o objetivo de oferecer uma experiência personalizada e funcional aos nossos usuários. Essas informações são divididas em duas categorias principais:
</div>




<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>1.1. Dados fornecidos pelo usuário</a><br/>
Esses dados são coletados diretamente de você ao acessar ou utilizar nossos serviços. Incluem:
<li>Informações de Cadastro: Nome completo, endereço de e-mail, e outros dados necessários para criar uma conta ou acessar determinados recursos.</li>
<li>Conteúdo enviado: Modelos 3D, mensagens ou arquivos compartilhados por meio da plataforma.</li>
<li>Informações de pagamento: Caso utilize serviços pagos, poderão ser coletados dados de pagamento (como número do cartão e informações de faturamento) por meio de plataformas seguras e autorizadas.</li>

</div>



<div style={{ marginTop: '25px'}}>

 <a style={{fontWeight: 'bold'}}>1.2. Dados coletados automaticamente</a><br/>
Esses dados são coletados automaticamente durante o uso do site, através de ferramentas como cookies e tecnologias similares. Incluem:
<li>Dados de Navegação: Endereço IP, tipo de navegador, idioma, sistema operacional e configurações do dispositivo.</li>
<li>Dados de Interação: Páginas acessadas, tempo de permanência no site, cliques e outras ações realizadas.</li>
<li>Localização: Dados aproximados da sua localização, baseados no endereço IP, para fins analíticos.</li>

</div>



<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>1.3. Dados obtidos de terceiros</a>
Podemos receber informações de terceiros confiáveis, como serviços de autenticação, caso você escolha se cadastrar ou fazer login utilizando plataformas como Google ou redes sociais.
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>1.4. Finalidade da coleta</a>
Todos os dados coletados têm como principal objetivo oferecer uma experiência otimizada, personalizada e segura. Para mais informações sobre como utilizamos esses dados, veja a próxima seção sobre Finalidade do Tratamento de Dados.</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>2. FINALIDADE DO TRATAMENTO DOS DADOS </a>
Os dados coletados pelo <a style={{fontWeight: 'bold'}}>Lumera 3D</a> são tratados com respeito à privacidade
 e transparência, sempre em conformidade com a <a style={{fontWeight: 'bold'}}>Lei Geral de Proteção de Dados Pessoais (LGPD). </a>
  Abaixo, descrevemos as principais finalidades para o tratamento das suas informações:</div>




<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>2.1. Prestação de serviços</a><br/>
<li>Permitir o acesso e uso dos recursos oferecidos pela plataforma, como o upload, compartilhamento e gerenciamento de modelos 3D.</li>
<li>Fornecer suporte técnico e responder às solicitações dos usuários.</li>
<li>Processar pagamentos e gerenciar transações, quando aplicável.</li>
</div>





<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>2.2. Personalização da experiência</a><br/>
<li>Personalizar a navegação e os conteúdos exibidos, de acordo com as preferências e interações do usuário.</li>
<li>Melhorar a experiência do usuário, com base em dados analíticos e feedbacks.</li>
</div>


<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>2.3. Comunicação com o usuário</a><br/>
<li>Enviar notificações importantes relacionadas ao funcionamento do site, como atualizações de políticas, mudanças em funcionalidades ou problemas técnicos.</li>
<li>Divulgar promoções, novidades e outros materiais relacionados aos nossos serviços, desde que previamente autorizado pelo usuário.</li>
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>2.4. Cumprimento de obrigações legais</a><br/>
<li>Atender a requisitos legais e regulatórios aplicáveis.</li>
<li>Responder a solicitações de autoridades governamentais ou judiciais, quando exigido.</li>
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>2.5. Segurança e prevenção a fraudes</a><br/>
<li>Garantir a segurança da plataforma e proteger contra atividades não autorizadas ou mal-intencionadas.</li>
<li>Monitorar e identificar possíveis violações dos Termos de Uso.</li>
</div>
<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>2.6. Desenvolvimento e melhoria dos serviços</a><br/>
<li>Analisar o uso da plataforma para identificar tendências e melhorar funcionalidades.</li>
<li>Realizar pesquisas e análises de mercado para entender as necessidades dos usuários e criar soluções mais eficazes.</li>
</div>
<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>Base Legal</a><br/>
O tratamento dos seus dados é realizado com base nas hipóteses previstas na LGPD, como o cumprimento de obrigações contratuais, o consentimento do titular, o legítimo interesse da empresa e o cumprimento de obrigações legais ou regulatórias.
</div>




<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>3. POLÍTICA DE COOKIES</a><br/>
Os cookies são pequenos arquivos de texto armazenados no seu dispositivo ao acessar o nosso site. Eles ajudam a melhorar sua experiência de navegação, fornecendo funcionalidades essenciais e informações para personalizar nossos serviços. No <a style={{fontWeight: 'bold'}}>Lumera 3D </a>, utilizamos cookies de forma transparente e em conformidade com a <a style={{fontWeight: 'bold'}}>Lei Geral de Proteção de Dados Pessoais (LGPD).</a>
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>3.1. Tipos de Cookies que Utilizamos</a><br/>
<li><a style={{fontWeight: 'bold'}}>Cookies Necessários:</a> Garantem o funcionamento adequado do site e não podem ser desativados. Incluem, por exemplo, cookies que permitem o login e o carregamento de modelos 3D.</li>
<li><a style={{fontWeight: 'bold'}}>Cookies de Desempenho:</a> Coletam informações sobre como os usuários interagem com o site, ajudando-nos a identificar problemas e melhorar sua experiência.</li>
<li><a style={{fontWeight: 'bold'}}>Cookies de Funcionalidade:</a> Permitem que o site se lembre de suas preferências (como idioma ou configurações de exibição) para oferecer uma experiência mais personalizada.</li>
<li><a style={{fontWeight: 'bold'}}>Cookies de Publicidade e Marketing:</a> Utilizados para apresentar anúncios relevantes e medir a eficácia de campanhas promocionais. Esses cookies podem ser de terceiros, como Google Ads ou redes sociais.</li>
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>3.2. Como Gerenciar Cookies</a><br/>
Você pode gerenciar ou desativar cookies diretamente nas configurações do seu navegador. No entanto, desativar alguns cookies pode impactar o funcionamento do site.
<li>Opções de Configuração:</li>
<li style={{paddingLeft: '20px'}}>Google Chrome: <a style={{cursor: 'pointer', color: 'rgb(39, 70, 132)'}}>Gerenciar Cookies no Chrome</a></li>
<li style={{paddingLeft: '20px'}}>Mozilla Firefox:<a style={{cursor: 'pointer', color: 'rgb(39, 70, 132)'}}> Gerenciar Cookies no Firefox</a></li>
<li style={{paddingLeft: '20px'}}>Microsoft Edge:<a style={{cursor: 'pointer', color: 'rgb(39, 70, 132)'}}> Gerenciar Cookies no Edge</a></li>
<li style={{paddingLeft: '20px'}}>Safari:<a style={{cursor: 'pointer', color: 'rgb(39, 70, 132)'}}> Gerenciar Cookies no Safari</a></li>
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>3.3. Cookies de Terceiros</a><br/>
Em nosso site, podemos utilizar cookies de terceiros para fins analíticos e de marketing. Esses cookies são gerenciados pelas respectivas empresas, que possuem suas próprias políticas de privacidade e práticas de coleta de dados.
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>3.4. Consentimento</a><br/>
Ao acessar nosso site pela primeira vez, você verá um aviso solicitando seu consentimento para o uso de cookies. Sua escolha será registrada, mas você poderá revisá-la a qualquer momento nas configurações do site ou do navegador.
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>3.5. Atualizações na Política de Cookies</a><br/>
Esta política poderá ser atualizada periodicamente para refletir mudanças nas práticas de uso de cookies. Recomendamos que você revisite esta seção regularmente.
</div>







<div style={{ marginTop: '25px'}}>

<a style={{fontWeight: 'bold'}}>4. ARMAZENAMENTO E SEGURANÇA DOS DADOS</a><br/>
No Lumera 3D, adotamos medidas técnicas e organizacionais para garantir que seus dados pessoais sejam armazenados de forma segura e protegida contra acessos não autorizados, alterações, divulgações ou destruições. Esta seção explica como tratamos o armazenamento e a segurança das suas informações.
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>4.1. Local de Armazenamento</a><br/>
Os dados coletados são armazenados em servidores seguros localizados no Brasil ou em outros países que possuam níveis adequados de proteção de dados, conforme previsto pela Lei Geral de Proteção de Dados Pessoais (LGPD). Utilizamos provedores de serviços confiáveis, que seguem práticas rigorosas de segurança.
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>4.2. Período de Retenção</a><br/>
Seus dados pessoais serão armazenados apenas pelo tempo necessário para cumprir as finalidades descritas nesta Política de Privacidade ou para atender exigências legais e regulatórias.
<li>Dados de cadastro: Retidos enquanto sua conta estiver ativa.</li>
<li>Dados de pagamento: Mantidos conforme exigido por leis fiscais e contábeis.</li>
<li>Dados de navegação: Utilizados por períodos específicos para fins analíticos, após o que são anonimizados ou excluídos.</li>
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>4.3. Medidas de Segurança Adotadas</a><br/>
Para proteger suas informações, implementamos práticas de segurança como:
<li>Criptografia de Dados: Informações sensíveis, como dados de login e pagamento, são transmitidas de forma criptografada (SSL/TLS).</li>
<li>Controle de Acesso: Apenas funcionários autorizados têm acesso aos dados, e mesmo assim, apenas na medida necessária para cumprir suas funções.</li>
<li>Monitoramento Contínuo: Realizamos auditorias regulares e monitoramento para identificar e corrigir possíveis vulnerabilidades.</li>
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>4.4. Gerenciamento de Incidentes de Segurança</a><br/>
Em caso de qualquer incidente de segurança que comprometa os seus dados, tomaremos as seguintes medidas:
<li>Notificação às autoridades competentes, conforme exigido pela LGPD.</li>
<li>Comunicação direta com os usuários afetados, explicando o ocorrido e as medidas tomadas.</li>
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>4.5. Responsabilidade do Usuário</a><br/>
Embora adotemos práticas rigorosas de segurança, também é essencial que você tome medidas para proteger suas informações:
<li>Não compartilhe sua senha com terceiros.</li>
<li>Use senhas fortes e seguras.</li>
<li>Fique atento a possíveis e-mails de phishing ou atividades suspeitas em sua conta.</li>
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>4.6. Exclusão dos Dados</a><br/>
Você pode solicitar a exclusão dos seus dados pessoais a qualquer momento, enviando uma solicitação para contato@lumera3d.com. Dados que devem ser retidos por exigências legais ou para proteção de direitos legais não serão excluídos até o término do período exigido.
</div>



















<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>5. DIREITOS DO USUÁRIO</a><br/>
Em conformidade com a <a style={{fontWeight: 'bold'}}>Lei Geral de Proteção de Dados Pessoais (LGPD)</a>, você, como titular dos dados pessoais, possui uma série de direitos que garantem maior transparência, controle e segurança sobre as informações fornecidas ao <a style={{fontWeight: 'bold'}}>Lumera 3D</a>. Abaixo, detalhamos seus direitos e como exercê-los:
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>5.1. Direito de Confirmação e Acesso</a><br/>
Você tem o direito de confirmar se estamos tratando seus dados pessoais e acessar as informações que mantemos sobre você.
<br/><a style={{fontWeight: 'bold'}}>Como exercer:</a> Envie um e-mail para <a style={{fontWeight: 'bold'}}>contato@lumera3d.com</a> solicitando a confirmação ou acesso aos seus dados.
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>5.2. Direito de Retificação</a><br/>
Se os seus dados estiverem incorretos, incompletos ou desatualizados, você pode solicitar a correção.
<br/><a style={{fontWeight: 'bold'}}>Como exercer:</a> Entre em contato pelo e-mail acima, especificando as informações que precisam ser corrigidas.
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>5.3. Direito de Exclusão (Eliminação de Dados)</a><br/>
Você pode solicitar a exclusão de seus dados pessoais tratados com base no seu consentimento, salvo em situações em que a retenção seja necessária para:
<li>Cumprimento de obrigações legais.</li>
<li>Exercício regular de direitos em processos judiciais, administrativos ou arbitrais.</li>
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>5.4. Direito à Portabilidade</a><br/>
Você pode solicitar a transferência dos seus dados pessoais para outro fornecedor de serviços ou produtos, respeitando as regulamentações da ANPD (Autoridade Nacional de Proteção de Dados).
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>5.5. Direito à Informação sobre Compartilhamento</a><br/>
Você tem o direito de saber com quais terceiros seus dados foram compartilhados e para qual finalidade.
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>5.6. Direito de Oposição</a><br/>
Se não concordar com o tratamento de seus dados com base em interesses legítimos, você pode se opor, desde que apresente justificativa fundamentada.
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>5.7. Direito de Revogação do Consentimento</a><br/>
Você pode revogar o consentimento fornecido para o tratamento de seus dados a qualquer momento. No entanto, a revogação pode impactar a continuidade de alguns serviços.
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>5.8. Direito à Revisão de Decisões Automatizadas</a><br/>
Se alguma decisão que afete seus interesses for tomada com base em tratamento automatizado de dados, você pode solicitar a revisão por uma pessoa.
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>Como exercer seus direitos?</a><br/>
Para exercer qualquer um dos direitos acima, envie sua solicitação para <a style={{fontWeight: 'bold'}}>contato@lumera3d.com</a>, informando:
<li>Seu nome completo.</li>
<li>O direito que deseja exercer.</li>
<li>Detalhes adicionais que possam facilitar o atendimento à sua solicitação.</li>
Prazos:<br/>
Nosso time analisará sua solicitação e responderá dentro do prazo de 15 dias, conforme exigido pela LGPD.
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>Importante</a><br/>
Alguns direitos podem estar sujeitos a limitações, especialmente quando o tratamento ou retenção dos dados for necessário para cumprir obrigações legais ou regulatórias.
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>6. CONTATO</a><br/>
<a style={{fontWeight: 'bold'}}>O Lumera 3D</a> está comprometido em garantir a transparência no tratamento de dados pessoais e em atender prontamente qualquer dúvida, solicitação ou preocupação em relação à sua privacidade. Caso precise entrar em contato conosco, utilize os canais abaixo:
</div>

<div style={{ marginTop: '25px'}}>
Informações de Contato:
E-mail: <a style={{fontWeight: 'bold'}}>contato@lumera3d.com</a>
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>Finalidades do Contato:</a><br/>
Você pode nos contatar para:
<li>Esclarecer dúvidas sobre esta Política de Privacidade ou sobre o tratamento dos seus dados.</li>
<li>Exercer os direitos previstos na LGPD (como acesso, retificação ou exclusão de dados).</li>
<li>Reportar possíveis violações de privacidade ou incidentes de segurança.</li>
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>Horário de Atendimento:</a><br/>
Nosso time está disponível de segunda a sexta-feira, das 10h às 15h (horário de Brasília), exceto feriados nacionais.
</div>
















       </div>
        
</div>





        </div>
        <Rodape/>
        </>
    )
}
export default PoliticasDePrivacidade;